export default __webpack_public_path__ + "static/media/7770ROUGE.124a3f3e.pdf";